import PropTypes from 'prop-types';
import Dialog from 'rc-dialog';
import ArcButton from '../ArcButton';
import './modal.scss';

function Modal(props) {
  const {
    title,
    width,
    visible,
    prefixCls,
    children,
    closeIcon,
    footer,
  } = props;

  const handleCancel = (e) => {
    const { onCancel } = props;
    onCancel?.(e);
  };

  const handleOk = (e) => {
    const { onOk } = props;
    onOk?.(e);
  };

  const defaultFooter = () => {
    const { okText, cancelText } = props;
    return (
      <>
        <ArcButton
          handleChecked={handleCancel}
          style={{ backgroundColor: '#fff', width: 5, height: 1.875 }}
          text={cancelText}
          id="cancel"
        />
        <ArcButton
          handleChecked={handleOk}
          style={{ backgroundColor: '#111', width: 5, height: 1.875 }}
          text={okText}
          id="cancel"
        />
      </>
    );
  };

  const closeIconToRender = (
    <span className={`${prefixCls}-close-x`}>
      {closeIcon || 'X'}
    </span>
  );

  return (
    <Dialog
      prefixCls={prefixCls}
      title={title}
      width={width}
      onClose={handleCancel}
      visible={visible}
      closeIcon={closeIconToRender}
      footer={footer || defaultFooter()}
    >
      {children}
    </Dialog>
  );
}

Modal.propTypes = {
  title: PropTypes.string,
  width: PropTypes.number,
  prefixCls: PropTypes.string,
  visible: PropTypes.bool,
  onOk: PropTypes.func,
  onCancel: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  closeIcon: PropTypes.element,
  okText: PropTypes.string,
  cancelText: PropTypes.string,
  footer: PropTypes.element,
};

Modal.defaultProps = {
  width: 520,
  prefixCls: 'aid-modal',
  title: '',
  visible: false,
  onOk: () => {},
  onCancel: () => {},
  children: '',
  closeIcon: null,
  okText: '确认',
  cancelText: '取消',
  footer: null,
};

export default Modal;
